import React from 'react';

import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const useStyles = makeStyles({
  row: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  clickable: {
    cursor: 'pointer',
  },
});

export function ExpandableTableRow(props) {
  const { children, columns, expandable, row } = props;

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  function handleRowClick() {
    if (expandable) {
      setExpanded(!expanded);
    }
  }

  function makeClasses() {
    if (expandable) {
      return [classes.row, classes.clickable].join(' ');
    }
    return classes.row;
  }

  function renderArrow() {
    if (!expandable) {
      return null;
    }

    return (
      <TableCell>
        <IconButton size="small">
          {expanded
            ? <KeyboardArrowUpIcon />
            : <KeyboardArrowDownIcon />}
        </IconButton>
      </TableCell>
    );
  }

  return (
    <React.Fragment>

      <TableRow hover className={makeClasses()} onClick={handleRowClick}>
        {renderArrow()}
        {columns.map(({ align, colSpan, emptyValue, field: name, render, size, type }) => {
          return (
            <TableCell
              align={align ? align : type === 'numeric' ? 'right' : 'left'}
              colSpan={colSpan}
              key={name}
              size={size}
            >
              {render
                ? render(row)
                : row.fields[name] ?? emptyValue}
            </TableCell>
          );
        })}
      </TableRow>

      <TableRow>
        <TableCell colSpan={12} style={{ padding: 0 }}>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box margin={1}>
              {children}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

    </React.Fragment>
  );
}
